import { find, equals } from 'ramda';
import { getComputedPropertyValue } from './getComputedProperyValue';

const regex = /(auto|scroll|overlay)/;
const parents = (node, ps) => (equals(null, node.parentNode) ? ps : parents(node.parentNode, ps.concat([node])));

const overflow = (node) =>
  getComputedPropertyValue(node, 'overflow') +
  getComputedPropertyValue(node, 'overflow-y') +
  getComputedPropertyValue(node, 'overflow-x');
const scroll = (node) => regex.test(overflow(node));

export const getScrollParent = (node) => {
  if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
    return;
  }

  return find(scroll, parents(node.parentNode, [])) || document.scrollingElement || document.documentElement;
};
